// LDCP-228 — backward-compatible shim; logic lives in safeText.js.

import { validationResult } from "./patterns";
import {
  ALLOWED_SPECIAL_CHARS,
  SAFE_TEXT_MESSAGE,
  filterSafeText,
  isSafeText,
} from "./safeText";

export { ALLOWED_SPECIAL_CHARS, SAFE_TEXT_MESSAGE, filterSafeText, isSafeText };

export const CHAR_POLICY_MESSAGES = {
  safeText: SAFE_TEXT_MESSAGE,
  shortName: SAFE_TEXT_MESSAGE,
  personName: SAFE_TEXT_MESSAGE,
  organisationName: SAFE_TEXT_MESSAGE,
  plainText: SAFE_TEXT_MESSAGE,
  plainTitle: SAFE_TEXT_MESSAGE,
};

export const CHAR_POLICY_HINTS = {
  safeText: SAFE_TEXT_MESSAGE,
  shortName: SAFE_TEXT_MESSAGE,
  personName: SAFE_TEXT_MESSAGE,
  organisationName: SAFE_TEXT_MESSAGE,
  plainText: SAFE_TEXT_MESSAGE,
  plainTitle: SAFE_TEXT_MESSAGE,
};

export function getCharPolicyHint(policy) {
  return CHAR_POLICY_HINTS[policy] || SAFE_TEXT_MESSAGE;
}

export function getCharPolicyFieldText(_policy, error) {
  return error || "";
}

export function policyHasCharHint() {
  return true;
}

export function validateCharPolicy(_policy, value, { allowEmpty = true } = {}) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed && !allowEmpty) return validationResult(true);
  if (isSafeText(value, { allowEmpty })) return validationResult(true);
  return validationResult(false, SAFE_TEXT_MESSAGE);
}

export function yupCharPolicyTest(_policy, { allowEmpty = true } = {}) {
  return function charPolicyTest(value) {
    const trimmed = String(value ?? "").trim();
    if (!trimmed && !allowEmpty) return true;
    if (isSafeText(value, { allowEmpty })) return true;
    return this.createError({ message: SAFE_TEXT_MESSAGE });
  };
}
